import {btn, Component, Notifier, router, tbar} from "@intermesh/goui";
import {t} from "./util/Translate.js";
import {registrationForm} from "./components/RegistrationForm.js";
import {CurrentParticipant} from "./services/CurrentParticipant.js";
import {frontendParticipantDS} from "./DataSources";

export class ConfirmParticipantEdit extends Component {
	constructor() {
		super("section");
		this.itemId = "confirm-registration";
		this.id = "confirm-registration";
		this.cls = "card";

		const p = registrationForm({readOnly: true});

		p.form.on("submit", async () => {
			p.form.findChild("remindMe")!.disabled = false;
			const v = p.form.value,
				cp = CurrentParticipant.get();
			let body = {
				id: cp.id,
				firstName: v.firstName,
				middleName: v.middleName,
				lastName: v.lastName,
				dateOfBirth: v.dateOfBirth,
				email: v.email,
				company: v.company,
				remindMe: v.remindMe,
				customFields: v.customFields,
			};
			if (Object.keys(v.customFields).length === 0) {
				delete body.customFields;
			}

			frontendParticipantDS.update(cp.id, body).then(async (result) => {

				await CurrentParticipant.refresh({success: true, data: result!, message:undefined});

				Notifier.success(t("Saved successfully"), 5000);
				void router.goto("profile");
			});

		});

		p.load().then(() => {
			this.items.add(p);
			p.form.findChild("username")!.hide();
			p.form.findChild("username")!.disabled = true;
			p.form.findChild("password")!.hide();
			p.form.findChild("password")!.disabled = true;
			p.form.findChild("passwordRepeat")!.hide();
			p.form.findChild("passwordRepeat")!.disabled = true;

			this.items.add(tbar({cls: "ifw-bbar"},
				btn({text: t("Back"), route: "participant-edit"}),
				"->",
				btn({
					type: "submit", text: t("Continue"), handler: () => {
						p.form.submit();
					}
				})
			));
		});
	}
}
